import 'ng-device-detector';
import { NgModule, bundle } from 'ng-metadata/core';
import { EnvDetectorService } from './env-detector.service';
import { EnvDetectorDirective } from './env-detector.directive';

/**
 * @ngdoc module
 * @name mw.components.envDetector
 * @description
 *
 * Environment Detector
 */
@NgModule({
    declarations: [ EnvDetectorDirective ],
    providers: [{ provide: 'mwEnvDetector', useClass: EnvDetectorService }],
    imports: ['ng.deviceDetector']
})
export class EnvDetectorModule {}


// export default angular
//     .module('mw.components.envDetector', ['ng.deviceDetector'])
//     .service('mwEnvDetector', EnvDetectorService)
//     .directive(EnvDetectorDirective.config.selector, () => EnvDetectorDirective.config);



// WEBPACK FOOTER //
// ./src/lib/components/env-detector/env-detector.module.ts